import { fetchSetupAssistantVerifiedComplete } from 'src/views/pages/SetupAssistantView/setupAssistantApi';

export const REFRESH_SETUP_ASSISTANT_OUTSTANDING = '@setup-assistant/refresh-outstanding';
export const REFRESH_SETUP_ASSISTANT_OUTSTANDING_SUCCESS = '@setup-assistant/refresh-outstanding-success';
export const REFRESH_SETUP_ASSISTANT_OUTSTANDING_ERROR = '@setup-assistant/refresh-outstanding-error';

// A route change refreshes the sidebar badge at most this often.
export const SETUP_ASSISTANT_OUTSTANDING_ROUTE_THROTTLE_MS = 60 * 1000;

// Only the newest request may write its answer, so a slow response to an
// older refresh can never overwrite the count from a newer one.
let latestRequestId = 0;

/**
 * refreshSetupAssistantOutstanding — the Setup Assistant sidebar badge.
 *
 * Reads GET /api/setup-assistant/verified-complete (read-only on the
 * server) and stores outstandingCount. Callers gate on SETUP_ASSISTANT and
 * CP texting before dispatching; this does not re-check.
 *
 * throttleMs: skip the call when the last request, from ANY caller, went
 * out less than that long ago. 0 (the default) always calls.
 *
 * A failure clears the count, which hides the badge. Nothing here retries.
 */
export const refreshSetupAssistantOutstanding = ({ throttleMs = 0 } = {}) => async (dispatch, getState) => {
  const { lastRequestedAt } = getState()?.setupAssistant || {};

  if (throttleMs > 0 && lastRequestedAt && Date.now() - lastRequestedAt < throttleMs) {
    return;
  }

  latestRequestId += 1;
  const requestId = latestRequestId;

  dispatch({
    type: REFRESH_SETUP_ASSISTANT_OUTSTANDING,
    payload: { requestedAt: Date.now() },
  });

  try {
    const data = await fetchSetupAssistantVerifiedComplete();

    if (requestId !== latestRequestId) return;

    dispatch({
      type: REFRESH_SETUP_ASSISTANT_OUTSTANDING_SUCCESS,
      payload: data,
    });
  } catch (e) {
    if (requestId !== latestRequestId) return;

    dispatch({ type: REFRESH_SETUP_ASSISTANT_OUTSTANDING_ERROR });
  }
};
